import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import { SeoExam } from '@medprev-web-app/api-graphql-client';
import { Activity } from 'react';

import { Button } from '@/components/ui/button/button.component';
import { Card } from '@/components/ui/card.component';
import { Link } from '@/components/ui/link/link.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { formatToTitleCase } from '@/utils/formatters/format-to-title-case';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

export interface ExamCardProps {
  exam: SeoExam;
  itemBaseUrl: string;
  titleBaseUrl: string;
  isFirst?: boolean;
}

export function SeoExamCard({ exam, itemBaseUrl, titleBaseUrl, isFirst = false }: ExamCardProps) {
  const keyUrl = `${titleBaseUrl}${exam?.slug}/`;

  return (
    <Card className={`md:mt-6 pt-0 border-x-0 sm:px-16 ${isFirst ? 'border-t' : 'border-t-0'} md:px-6 md:border-t md:border-b md:border-x rounded-none md:rounded-xl`}>
      <Link
        prefetch={false}
        href={keyUrl}
        data-testid={DataTestIdEnum.INDEX_LINK_BY_HEADER_NAME}
        className="bg-green-100 hover:bg-green-200 text-gray-700 rounded-b w-fit flex items-center px-5 py-1 hover:underline"
        data-analytics-event={AnalyticsEnum.CLICK_TITLE_EXAM_IN_CARD}
        data-analytics-properties={JSON.stringify({ exame_nome: exam.name })}
      >
        <Typography variant={TypographyVariant.MEDIUM_BODY_TEXT} className="font-semibold text-gray-700">
          {exam.name}
        </Typography>
      </Link>

      <ul className="mt-4 space-y-4">
        {exam?.seoMainCities?.map((city, index, cities) => (
          <li key={city?.slug}>
            <Link
              prefetch={false}
              href={`${itemBaseUrl}${exam?.slug}-em-${city?.slug}/`}
              data-testid={DataTestIdEnum.INDEXING_CARD_CITY_NAME}
              className="text-green-500 font-bold hover:underline"
              data-analytics-event={AnalyticsEnum.CLICK_EXAM_BY_CITY}
              data-analytics-properties={JSON.stringify({ exame: exam.name, cidade: city?.name, estado: city?.state_abbr })}
            >
              {`${formatToTitleCase(String(exam?.name))} em ${city?.name} - ${city?.state_abbr}`}
            </Link>
            {(index !== cities.length - 1 || cities.length >= 5) && (
              <hr className="mt-4" />
            )}
          </li>
        ))}
      </ul>

      <Activity mode={(exam?.seoMainCities?.length ?? 0) > 4 ? 'visible' : 'hidden'}>

        <Link
          prefetch={false}
          data-testid={DataTestIdEnum.INDEXING_CARD_SEE_MORE}
          href={keyUrl}
          data-analytics-event={AnalyticsEnum.CLICK_SEE_EVERY_EXAM_BY_EXAM_CARD}
          data-analytics-properties={JSON.stringify({ exame_nome: exam.name })}
        >
          <Button variant="text" className="w-fit mt-4 font-bold" startIcon={faPlus}>
            Ver mais
          </Button>
        </Link>
      </Activity>
    </Card>
  );
};
